import React from 'react';
import { Button } from '../ui/Button';
import styles from './AdvanceRetry.module.css';

interface AdvanceRetryProps {
  onRetry: () => void;
  /** True while an advance is already in flight. */
  disabled?: boolean;
}

/**
 * Inline row shown after the last message when an automatic advance failed:
 * the conversation stays put and the learner can re-run the same advance (#250).
 */
export const AdvanceRetry: React.FC<AdvanceRetryProps> = ({
  onRetry,
  disabled = false,
}) => (
  <div className={styles.advanceRetry} role="status" aria-live="polite">
    <span>Couldn&apos;t continue.</span>
    <Button variant="outlined" onClick={onRetry} disabled={disabled}>
      Try again
    </Button>
  </div>
);

export default AdvanceRetry;
